import { BaseModel } from '@/types/models/BaseModel';
import AxiosConfiguration from '@/classes/AxiosConfiguration';
import { MStoreInputInlineUpdateModel } from '@/types';

export const MStoreInputInlineUpdateService = {
  async updateDataAsync(apiUrl: string, mStoreInputInlineUpdateModel: MStoreInputInlineUpdateModel):
    Promise<BaseModel> {
    const response = await AxiosConfiguration.axiosWithoutNotification.put(apiUrl, mStoreInputInlineUpdateModel);
    return response.data;
  }
};